module.exports = "/images/vendor/jquery-ui-dist/ui-icons_ffffff_256x240.png?3ae0c37ecc29205a8923897bfb01c459";